import { forwardRef } from 'react';
import ChevronIcon from '@assets/img/icons/chevron.svg?react';
import { motion } from 'framer-motion';

import { type SvgIconProps } from '@/common/types/components';

const ChevronComponent = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => {
    return <ChevronIcon ref={ref} {...props} />;
  },
);

const MotionChevronIcon = motion.create(ChevronComponent);

export { MotionChevronIcon };
